import React from "react";

const ITEMS = [
  "Licensed & Insured",
  "Free Inspections",
  "Insurance Claim Experts",
  "24/7 Emergency Service",
  "Manufacturer Warranties",
  "Residential & Commercial",
  "All of Arizona",
  "Backed By Pro West",
];

export const TrustBar = () => {
  return (
    <div data-testid="trust-bar" className="bg-[#D86C1E] py-4 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee">
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading font-bold uppercase tracking-wide text-white text-sm px-6">
              {item}
            </span>
            <span className="text-white/60 text-lg">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustBar;
